export default __webpack_public_path__ + "static/media/bi_apple.8a9cc74a.svg";